export default __webpack_public_path__ + "static/media/wetu.af3529ed.svg";